import { gql } from "@apollo/client";

export const GET_MY_TICKETS = gql`
  query GetMyTickets(
    $spaceId: ID
    $status: String
    $priority: String
    $search: String
    $limit: Int
    $offset: Int
  ) {
    myTickets(
      spaceId: $spaceId
      status: $status
      priority: $priority
      search: $search
      limit: $limit
      offset: $offset
    ) {
      tickets {
        id
        ticketNumber
        subject
        description
        status
        priority
        customerName
        customerEmail
        createdBy {
          id
          name
          email
          avatar
        }
        assignedTo {
          id
          name
          email
          avatar
        }
        messages {
          id
          content
          timestamp
        }
        createdAt
        updatedAt
      }
      total
    }
  }
`;

export const GET_TICKET = gql`
  query GetTicket($id: ID!) {
    ticket(id: $id) {
      id
      ticketNumber
      subject
      description
      status
      priority
      customerName
      customerEmail
      createdBy {
        id
        name
        email
        avatar
      }
      assignedTo {
        id
        name
        email
        avatar
      }
      messages {
        id
        sender {
          id
          name
          email
          avatar
        }
        senderName
        content
        timestamp
        isInternal
      }
      history {
        id
        action
        performedBy {
          id
          name
          email
          avatar
        }
        performedByName
        timestamp
        oldValue
        newValue
        details
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_ASSIGNABLE_USERS = gql`
  query GetAssignableUsers($spaceId: ID) {
    ticketAssignableUsers(spaceId: $spaceId) {
      id
      name
      email
      avatar
    }
  }
`;
